import { GeoCoordinates, ManualGeoItemArray } from '../../../@types/types'

export const geoManualHierarchyResultsToApp = (result: ManualGeoItemArray) =>
  result.map(({ id, name, geoCoordinates }) => {
    if (geoCoordinates)
      return {
        value: id.toString(),
        label: name,
        geoCoordinates: geoCoordinatesToApp(geoCoordinates),
      }
    else return { value: id.toString(), label: name }
  })

export const geoCoordinatesToApp = ({
  latitude,
  longitude,
  lambertEuCoordinatesX,
  lambertEuCoordinatesY,
}: GeoCoordinates): GeoCoordinates => ({
  latitude,
  longitude,
  lambertEuCoordinatesX,
  lambertEuCoordinatesY,
})
